import React from 'react';
import moment from "dayjs";

import {
    PopupTitle,
    PopupContainer,
    PopupDescription,
    PopupButtonsContainer,
    PopupButton,
    TitleContainer
} from "../CandidateView.styles";

interface RequestResumeActionProps {
    onConfirm: () => Promise<void>
    onCancel: () => void
    freePeriod?: {
        endDate: Date
    }
    isRecentlyViewed: boolean
}

const RequestResumeAction = ({
    onConfirm,
    onCancel,
    freePeriod,
    isRecentlyViewed
}: RequestResumeActionProps) => {
    return (
        <PopupContainer>
            <TitleContainer><PopupTitle>View Candidate's Resume?</PopupTitle></TitleContainer>
            <PopupDescription>
                {freePeriod && (
                    <p>
                        Great news!<br/><br/>
                        Normally you'd use a token to view this candidate's resume - but TempStars is FREE for you until {moment(freePeriod.endDate).format('MMMM Do, YYYY')}!
                        <br/>
                        <br/>
                        We're doing our part to support our fellow dental professionals during this difficult post-COVID time.<br/><br/>
                        Stay safe!
                    </p>
                )} 
                {isRecentlyViewed && !freePeriod && ( 
                    <p>
                        Great news!
                        <br/>
                        <br/>
                        Normally you would use 1 token to view this resume, but it looks like this candidate has previously applied to you within the last 3 months, so we won’t charge a token to view this resume today.
                    </p>)}

                {!isRecentlyViewed && !freePeriod && (
                    <p>Viewing this resume will use 1 token.</p>
                )}
            </PopupDescription>
            <PopupButtonsContainer>
                <PopupButton
                    variant="outlined"
                    onClick={onCancel}
                    color="primary"
                    size="large"
                    id="cancel-button"
                    className="bigButtonInNewStyle"
                >
                    Cancel
                </PopupButton>
                <PopupButton
                    variant="contained"
                    onClick={onConfirm}
                    color="primary"
                    size="large"
                    id="confirm-button"
                    className="bigButtonInNewStyle"
                >
                    View
                </PopupButton>
            </PopupButtonsContainer>
        </PopupContainer>
    )
}

export default RequestResumeAction;
